module.exports = __webpack_public_path__ + "img/examination-video-2.9a41e8e2.jpg";